<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="medium" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12 style="padding: 1rem 0 0 1rem")
        h3 {{supplierName}}
      vm-col(vm-justify="center", vm-align="center", vm-w=5.5)
        b-form-group
          vm-date-picker.date(:label="$t('concepts.created_at')" :placeholder="$t('strings.select_date')" v-model="form.date" @on-change="setDateAlert")
      vm-col(vm-justify="center", vm-align="center", vm-w=5.5 v-if="(supplierName!==null && isAdd==true)")
        b-form-group
          vm-input(autofocus :danger="$v.form.charge.$invalid" :danger-text="$t('validation.required', { attribute: $t('concepts.charge') })" v-model="form.charge" :label='$t("concepts.charge")' @focus="$event.target.select()" type="currency")
      vm-col(vm-justify="center", vm-align="center", vm-w=5.5)
        b-form-group
          vm-select(v-if="supplierName==null" :placeholder='$t("concepts.conceptable_type_placeholder")' :danger="$v.form.conceptable_type.$invalid && $v.form.conceptable_type.$model" :danger-text="$t('validation.required', { attribute: $t('concepts.conceptable_type') })" v-model="form.conceptable_type" :label='$t("concepts.conceptable_type")')
            vm-select-item(:key="index" :value="item.class" :text="item.text" v-for="(item,index) in types")
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="supplierName==null")
        b-form-group
          vm-typeahead(v-if="form.conceptable_type === types[0].class" url="administrative_concepts" :label='$t("concepts.administrative_concept")' disable-match :danger="$v.form.conceptable_id.$invalid && $v.form.conceptable_id.$model" :danger-text="$t('validation.required', { attribute: $t('concepts.conceptable_id') })" :serializer="item => item.name" required :data="catalog.administrative_concepts" :placeholder='$t("concepts.administrative_concept_placeholder")' v-model="form.conceptable_id" :filter="query => `?param=${query},concept`" @input-change="autoCompleteFunc" :default-value="form.conceptable && form.conceptable.name")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
          vm-typeahead(v-if="form.conceptable_type === types[1].class" url="projects" :label='$t("concepts.project")' disable-match :danger="$v.form.conceptable_id.$invalid && $v.form.conceptable_id.$model" :danger-text="$t('validation.required', { attribute: $t('concepts.conceptable_id') })" :serializer="item => item.name" required :data="catalog.projects" :placeholder='$t("concepts.project_placeholder")' v-model="form.conceptable_id" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc" :default-value="form.conceptable && form.conceptable.name")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
          vm-typeahead(v-if="form.conceptable_type === types[2].class" url="suppliers" :label='$t("concepts.supplier")' disable-match :danger="$v.form.conceptable_id.$invalid && $v.form.conceptable_id.$model" :danger-text="$t('validation.required', { attribute: $t('concepts.conceptable_id') })" :serializer="item => item.name" required :data="catalog.suppliers" :placeholder='$t("concepts.supplier_placeholder")' v-model="form.conceptable_id" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc" :default-value="form.conceptable && form.conceptable.name")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("concepts.concept_placeholder")' :danger="$v.form.concept.$invalid && $v.form.concept.$model" :danger-text="$t('validation.required', { attribute: $t('concepts.concept') })" v-model="form.concept" :label='$t("concepts.concept")')
      vm-col(vm-justify="center", vm-align="center", vm-w=5.5 v-if="supplierName==null || isAdd==false")
        b-form-group
          vm-input(autofocus :danger="$v.form.payment.$invalid" :danger-text="$t('validation.required', { attribute: $t('concepts.payment') })" v-model="form.payment" :label='$t("concepts.payment")' :disabled="form.charge > 0" @focus="$event.target.select()" type="currency")
      vm-col(vm-justify="center", vm-align="center", vm-w=5.5 v-if="supplierName==null || isAdd==false")
        b-form-group
          vm-input(autofocus :danger="$v.form.charge.$invalid" :danger-text="$t('validation.required', { attribute: $t('concepts.charge') })" v-model="form.charge" :label='$t("concepts.charge")' :disabled="form.payment > 0" @focus="$event.target.select()" type="currency")
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="supplierName==null && isAdd!==false")
        b-form-group
          vm-select(:placeholder='$t("concepts.status_placeholder")' :danger="$v.form.status.$invalid && $v.form.status.$model" :danger-text="$t('validation.required', { attribute: $t('concepts.status') })" v-model="form.status" :label='$t("concepts.status")')
            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import moment from 'moment'
import { required, requiredIf, minValue } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Concepts')

export default {
  name: 'ModalConcepts',
  mixins: [ModalMixin1],
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    supplierName: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    types: [
      {
        text: 'Administrativo',
        class: 'App\\Models\\AdministrativeConcept'
      },
      {
        text: 'Obra',
        class: 'App\\Models\\Project'
      },
      {
        text: 'Proveedor',
        class: 'App\\Models\\Supplier'
      }
    ],
    status: [
      {
        text: 'Pagado',
        value: 1
      },
      {
        text: 'Facturado',
        value: 2
      }
    ]
  }),
  validations () {
    return {
      form: {
        date: {
          required
        },
        conceptable_type: {
          required
        },
        conceptable_id: {
          required
        },
        concept: {
          required
        },
        payment: {
          required: requiredIf(function () {
            return this.form.charge === 0 || this.form.charge == null
          }),
          minValue: minValue(this.minValuePayment)
        },
        charge: {
          required: requiredIf(function () {
            return this.form.payment === 0 || this.form.payment == null
          }),
          minValue: minValue(this.minValueCharge)
        },
        status: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog']),
    minValuePayment () {
      return this.form.charge > 0 ? 0 : 1
    },
    minValueCharge () {
      return this.form.payment > 0 ? 0 : 1
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'loadCatalog',
      'setEarlyDateAlert',
      'setFutureDateAlert'
    ]),
    close () {
      this.$emit('closeModal')
    },
    saveRecord () {
      this.isAdd ? this.addRecord({ ...this.form }) : this.editRecord({ ...this.form })
      this.$emit('updateRecords', this.form, this.isAdd)
      this.close()
    },
    async setDateAlert () {
      if ((moment(this.form.date).format('YYYY') === '2022') || moment(this.form.date).format('YYYY') < '2022') {
        await this.setEarlyDateAlert()
        this.form.date = moment().format('YYYY-MM-DD')
      } else if (moment(this.form.date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
        await this.setFutureDateAlert()
        this.form.date = moment().format('YYYY-MM-DD')
      }
    }
  }
}
</script>
<style lang="scss">
.date {
  padding: 5px 10px;
  width: 100%;
}
</style>
